/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BootstrapClientRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {BootstrapClientResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const bootstrapClient = (request: BootstrapClientRequest, options?: CashRequestOptions) => post<BootstrapClientRequest, BootstrapClientResponse>("/cash-app/local/profiles/bootstrap", request, {...options, rejectOnError: true })